// Set CSS Classes for iOS devices on html tag
(function () {
  try {
    const userAgent = navigator.userAgent;
    const iOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
    const webkit = !!userAgent.match(/WebKit/i);
    const CriOS = !!userAgent.match(/CriOS/i);
    const iOSSafari = iOS && webkit && !CriOS;
    if (iOS) {
      document.documentElement.classList.add('ios');
      const iPhoneVersion = navigator.userAgent.split('iPhone OS ')[1]?.split(' like')[0]?.replaceAll('_','.');
      iPhoneVersion && document.documentElement.classList.add(`ios-version-${iPhoneVersion}`);
    }
    if (iOSSafari) {
      document.documentElement.classList.add('ios-safari');
      const safariVersion = navigator.userAgent.split('Safari/')[1].split(' ')[0];
      safariVersion && document.documentElement.classList.add(`safari-version-${safariVersion}`);
    }
    if (CriOS) document.documentElement.classList.add('ios-chrome');
  } catch(err) {
    console.error(err);
  }
})();